module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-Regular_1_11666efa.551e1b4c.eot";